import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { usePlanoContext } from "../contexts/PlanoContext.tsx";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const { isLoading, isPlanActive } = usePlanoContext();

  if (!token) return <Navigate to="/" replace />;

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (
    location.pathname === "/meu-plano" ||
    location.pathname === "/planos/listagem" ||
    location.pathname === "/admin"
  ) {
    return children;
  }

  if (!isPlanActive) return <Navigate to="/meu-plano" replace />;

  return children;
};

export default ProtectedRoute;
